export var config = {
  background: '#002451',
  foreground: '#ffffff',
  selection: '#003f8e',
  selectionMatch: '#003f8e',
  cursor: '#ffffff',
  dropdownBackground: '#001733',
  activeLine: '#00346e7a',
  matchingBracket: '#00346e',
  keyword: '#EBBBFF',
  storage: '#EBBBFF',
  variable: '#FFC58F',
  parameter: '#FFC58F',
  function: '#BBDAFF',
  string: '#D1F1A9',
  constant: '#FFC58F',
  type: '#FFEEAD',
  class: '#BBDAFF',
  number: '#FFC58F',
  comment: '#7285B7',
  heading: '#D1F1A9',
  invalid: '#a92049',
  regexp: '#D1F1A9',
  tag: '#FF9DA4'
};